module.exports = {
  PLAYERS: 'players',
  SPECIES: 'species',
  LEADERS: 'leaders',
  INVENTORY: 'inventory',
  EVENTS: 'events',

  PLAYERS_ALPHA: 'players-alpha',
  SPECIES_ALPHA: 'species-alpha',
  LEADERS_ALPHA: 'leaders-alpha',
  INVENTORY_ALPHA: 'inventory-alpha',
  EVENTS_ALPHA: 'events-alpha'
};
